import React, { useState } from 'react';
import { withRouter, WithRouterProps } from 'react-router';
import I18n from 'i18n-js';

import { RCCheckbox } from '@reverbdotcom/cadence/components';
import ProximityModal, { MILES_100 } from '@reverbdotcom/commons/src/components/proximity_modal';
import { getProximityFilterText, PROXIMITY_PARAM, proximityParams } from '@reverbdotcom/commons/src/components/proximity_facet';
import { SearchRemixer_FacetFieldsFragment } from '@reverbdotcom/commons/src/gql/graphql';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { useUpdateUrl } from '@reverbdotcom/commons/src/components/with_update_url';

interface ExternalProps {
  facet: SearchRemixer_FacetFieldsFragment,
  disabled?: boolean,
}

type IProps = ExternalProps & WithRouterProps;

export function ProximityFacetOption({ facet, disabled, location, router }: IProps) {
  const user = useUser();
  const { updateUrl } = useUpdateUrl();
  const [modalOpen, setModalOpen] = useState(false);

  const currentPostalCode = location?.query?.postal_code || user.postalCode;
  const currentDistance = location?.query?.distance || MILES_100;

  const displayName = getProximityFilterText(currentDistance, currentPostalCode, false);

  function handleClick(e: React.ChangeEvent) {
    if (!currentPostalCode) {
      e.preventDefault();
      e.stopPropagation();
      setModalOpen(true);
      return;
    }
    const baseParams = facet.selected ? { [PROXIMITY_PARAM]: [] } : { [PROXIMITY_PARAM]: ['true'] };
    const newUrl = updateUrl({
      location,
      newParams: proximityParams(
        baseParams,
        currentPostalCode,
        currentDistance,
        false,
      ),
    });

    router.push(newUrl);
  }

  return (
    <>
      <div className="d-flex gap-1 fx-align-start">
        <RCCheckbox
          id={facet.displayName}
          key={`${facet.displayName}-${facet.selected}`} // force a re-render of the checkbox when the selected state changes
          checked={facet.selected}
          onChange={handleClick}
          paddedHover
          disabled={disabled}
          label={displayName}
        />
        <button
          type="button"
          className="button-as-link padding-half"
          onClick={(e) => {
            e.preventDefault();
            setModalOpen(true);
          }}
        >
          <span className="text-utility-350 text-utility--semibold">
            {I18n.t('commons.proximityFilter.modalButton')}
          </span>
        </button>
      </div>
      <ProximityModal
        isModalOpen={modalOpen}
        setModal={setModalOpen}
        propsPostalCode={currentPostalCode}
        propsDistance={currentDistance}
        includeRadiusDropdown={true}
        additionalQueryParams={{ [PROXIMITY_PARAM]: true }}
        shouldApplyDistanceQueryParam={true}
        shouldApplyPostalCodeQueryParam
      />
    </>
  );
}

export default withRouter(ProximityFacetOption);
